import { render, staticRenderFns } from "./PlansFeaturesTable.vue?vue&type=template&id=ef56e030&scoped=true&"
import script from "./PlansFeaturesTable.vue?vue&type=script&lang=js&"
export * from "./PlansFeaturesTable.vue?vue&type=script&lang=js&"
import style0 from "./PlansFeaturesTable.vue?vue&type=style&index=0&id=ef56e030&lang=scss&scoped=true&"
import style1 from "./PlansFeaturesTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef56e030",
  null
  
)

export default component.exports